// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreateCredentialInstanceRequestPayload,
  TCreateCredentialInstanceResponsePayload,
  TDeleteCredentialInstanceRequestPayload,
  TDeleteCredentialInstanceResponsePayload,
  TGetCredentialOptionsRequestPayload,
  TGetCredentialOptionsResponsePayload,
  TGetProjectJiraFieldsRequestPayload,
  TGetProjectJiraFieldsResponsePayload,
  TGetProjectZendeskFieldsRequestPayload,
  TGetProjectZendeskFieldsResponsePayload,
  TListCredentialInstancesRequestPayload,
  TListCredentialInstancesResponsePayload,
  TListCredentialTemplatesRequestPayload,
  TListCredentialTemplatesResponsePayload,
  TProcessSlackCodeRequestPayload,
  TProcessSlackCodeResponsePayload,
  TTestCredentialConnectionRequestPayload,
  TTestCredentialConnectionResponsePayload,
  TUpdateCredentialInstanceRequestPayload,
  TUpdateCredentialInstanceResponsePayload,
} from './integrations.types.ts';

export const createIntegrationsApi = (transport: TApiTransport) => ({
  /** Creates an integration credential */
  createCredentialInstance: (
    payload: TCreateCredentialInstanceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateCredentialInstanceRequestPayload,
      TCreateCredentialInstanceResponsePayload
    >('/create_credential_instance', payload, options),

  /** Deletes an integration credential */
  deleteCredentialInstance: (
    payload: TDeleteCredentialInstanceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteCredentialInstanceRequestPayload,
      TDeleteCredentialInstanceResponsePayload
    >('/delete_credential_instance', payload, options),

  /** Lists what a stored credential can be pointed at, read live from the provider */
  getCredentialOptions: (
    payload: TGetCredentialOptionsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetCredentialOptionsRequestPayload,
      TGetCredentialOptionsResponsePayload
    >('/get_credential_options', payload, options),

  /** Returns the project's Jira fields */
  getProjectJiraFields: (
    payload: TGetProjectJiraFieldsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectJiraFieldsRequestPayload,
      TGetProjectJiraFieldsResponsePayload
    >('/get_project_jira_fields', payload, options),

  /** Returns the project's Zendesk fields */
  getProjectZendeskFields: (
    payload: TGetProjectZendeskFieldsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectZendeskFieldsRequestPayload,
      TGetProjectZendeskFieldsResponsePayload
    >('/get_project_zendesk_fields', payload, options),

  /** Lists integration credentials */
  listCredentialInstances: (
    payload: TListCredentialInstancesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListCredentialInstancesRequestPayload,
      TListCredentialInstancesResponsePayload
    >('/list_credential_instances', payload, options),

  /** Lists integration credential templates */
  listCredentialTemplates: (
    payload: TListCredentialTemplatesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListCredentialTemplatesRequestPayload,
      TListCredentialTemplatesResponsePayload
    >('/list_credential_templates', payload, options),

  /** Completes the Slack OAuth flow */
  processSlackCode: (
    payload: TProcessSlackCodeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TProcessSlackCodeRequestPayload,
      TProcessSlackCodeResponsePayload
    >('/process_slack_code', payload, options),

  /** Checks whether a stored credential authenticates against its provider. Read-only; creates nothing. */
  testCredentialConnection: (
    payload: TTestCredentialConnectionRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TTestCredentialConnectionRequestPayload,
      TTestCredentialConnectionResponsePayload
    >('/test_credential_connection', payload, options),

  /** Updates an integration credential */
  updateCredentialInstance: (
    payload: TUpdateCredentialInstanceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateCredentialInstanceRequestPayload,
      TUpdateCredentialInstanceResponsePayload
    >('/update_credential_instance', payload, options),
});
